import { authRoles } from 'app/auth';
import ProjectEditForm from './editform/ProjectEditForm';
import ProjectTable from './table/ProjectTable';

export default [
	{
		path: '/project/edit/:id',
		component: ProjectEditForm,
		auth: authRoles.project
	},
	{
		path: '/project/:sessionNameParam?',
		component: ProjectTable,
		auth: authRoles.project
	}
];
